<template>
  <div class="index">
    <!-- 筛选 -->
    <section>
      <el-form class="section-filter" :model="filterForm" :inline="true" label-width="100px">
        <div class="filter-col">
          <!-- <el-form-item label="合同名称：">
            <el-input clearable v-model="filterForm.name" placeholder="请输入合同名称"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="案件名称：">
            <el-input clearable v-model="filterForm.entrustContract.caseName" placeholder="请输入案件名称"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="起始时间">
            <el-date-picker
              size="mini" type="datetime" default-time="00:00:00" v-model="filterForm.startSalaryMillisecond" :style="'width:200px;'"
              format="yyyy-MM-dd HH:mm:ss" value-format="timestamp" placeholder="选择时间"></el-date-picker>
          </el-form-item>
          <el-form-item label="截止时间">
            <el-date-picker
              size="mini" type="datetime" default-time="00:00:00" v-model="filterForm.endSalaryMillisecond" :style="'width:200px;'"
              format="yyyy-MM-dd HH:mm:ss" value-format="timestamp" placeholder="选择时间"></el-date-picker>
          </el-form-item> -->
        </div>
        <div class="filter-area">
          <div class="filter-area-label">地区：</div>
          <AreaPicker ref="AreaPicker" @getData="filterHandler" />
        </div>
        <div class="filter-btn">
          <el-button type="primary" @click="filterHandler()" icon="el-icon-search">查询</el-button>
        </div>
      </el-form>
    </section>
    <!-- 用户操作按钮 -->
    <section class="section-btns">
      <!-- <el-button type="" icon="el-icon-view" @click="viewHandler" v-if="btnShow.search" :disabled="selectRows.length!==1">查看</el-button> -->
      <el-button type="primary" icon="el-icon-plus" @click="createHandler" v-if="btnShow.create">创建</el-button>
      <el-button type="primary" icon="el-icon-edit" @click="modifyHandler" v-if="btnShow.modify" :disabled="selectRows.length!==1">编辑</el-button>
      <!-- <el-upload
        :action="importAction"
        accept=".xls,.xlsx" :limit="1" style="margin:0 10px;" :file-list="importFiles"
        :before-upload="beforeImport" :on-success="importSuccess" v-if="btnShow.import">
        <el-button type="success" icon="el-icon-upload2">数据导入</el-button>
      </el-upload> -->
      <!-- <el-button type="success" icon="el-icon-download" @click="downloadHandler">下载模板</el-button> -->
      <!-- <el-button type="success" icon="el-icon-download" @click="$refs.DownloadByArea.visible=true">下载模板</el-button> -->
      <!-- <el-button type="success" icon="el-icon-download" @click="exportHandler()" v-if="btnShow.export">数据导出</el-button> -->
      <el-button type="danger" icon="el-icon-delete" @click="deleteHandler" :disabled="selectRows.length<1" v-if="btnShow.delete">删除</el-button>
    </section>
    <!-- 数据表格 -->
    <section class="table">
      <el-table :data="tableData" max-height="550" border highlight-current-row @selection-change="checkHandler">
        <!--  @current-change="selectHandler" -->>
        <el-table-column  type="selection" width="40"></el-table-column>
        <el-table-column
          show-overflow-tooltip v-for="(x,i) in baseInfo" :key="i"
          :prop="x.key" :label="x.label" :fixed="x.fixed||false" :align="x.align||'center'"></el-table-column>

        <el-table-column label="文件" width="362" align="center">
          <template slot-scope="scope">

            <template v-if="Array.isArray(scope.row.fileNameAndIds)">
              <p v-for="(x,i) in scope.row.fileNameAndIds" :key="i" class="file-item">
                <span class="file-name">{{x.fileName}}</span>
                <a :href="'https://view.officeapps.live.com/op/view.aspx?src='+puUrl_x+'/'+x.fileId" target="_blank">
                  <el-button size="mini" plain type="success">预览</el-button>
                </a>
                <a :download="x.fileName" :href="puUrl_x+'/'+x.fileId" target="_blank" style="margin-left:10px;">
                  <el-button size="mini" plain type="primary">下载</el-button>
                </a>
              </p>
            </template>

            <template v-else-if="scope.row.fileNameAndIds">
              <p class="file-item">
                <span class="file-name">{{scope.row.fileNameAndIds.fileName}}</span>
                <a :href="'https://view.officeapps.live.com/op/view.aspx?src='+puUrl_x+'/'+scope.row.fileNameAndIds.fileId" target="_blank">
                  <el-button size="mini" plain type="success">预览</el-button>
                </a>
                <a :download="scope.row.fileNameAndIds.fileName" :href="puUrl_x+'/'+scope.row.fileNameAndIds.fileId" target="_blank" style="margin-left:10px;">
                  <el-button size="mini" plain type="primary">下载</el-button>
                </a>
              </p>
            </template>

          </template>
        </el-table-column>

        <!-- <el-table-column label="支付凭证" width="121" align="center">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px" :src="scope.row.transferUrl|toimg" fit="fill"
              :preview-src-list="[scope.row.transferUrl]|toimgs" v-if="scope.row.transferUrl"></el-image>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="340" align="center">
          <template slot-scope="scope">
            <el-button size="mini" plain type="success" @click="signContractHandler(scope.row.id)" :disabled="scope.row.ok">通过</el-button>
          </template>
        </el-table-column> -->

      </el-table>
      <Pagenation :pageData="pageData" @pageChange="pageChange"></Pagenation>
    </section>

    <!-- 模态框 查看模式 -->
    <DialogView
      ref="DialogView"
      :dialogTitle="dialogTitle"
      :formItems="formItems_"
      :formItems2="null"
      dialogWidth="1000px" />

    <!-- 模态框 编辑模式 -->
    <DialogEdit
      ref="DialogEdit"
      :rules="rules"
      :dialogTitle="dialogTitle"
      :action="$api.url_upload_pu"
      :formItems="formItems"
      :formItems2="null"
      @submitHandler="editSubmitHandler"
      dialogWidth="1000px" />
      <!-- :isShowArea="true" -->

    <el-dialog
			title="导入提示"
			:close-on-click-modal="false"
			:visible.sync="isShowImportTip"
      :append-to-body="true"
			width="500px">
      <div v-html="importResult" style="text-align:left"></div>
    </el-dialog>

    <!-- <DownloadByArea ref="DownloadByArea" :xlsCode="xlsCode" /> -->
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import DialogEdit from '@/components/DialogEdit'
import DialogView from '@/components/DialogView'
// import AreaPicker from '@/components/AreaPicker_3'
import AreaPicker from '@/components/AreaPicker'
import Pagenation from '@/components/Pagenation'
import DownloadByArea from '@/components/DownloadByArea'
import mixin_upload from '@/Mixins/mixin_upload'
import mixins from '@/Mixins/mixin_com'
import { powerMap } from '@/publicData/powerData'
export default {
  mixins: [mixins, mixin_upload],
  components: { AreaPicker, DialogView, DialogEdit, Pagenation, DownloadByArea },
  data() {
    return {
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
      sign: 'yz_ws_zhengju',
      docType: 'yz_ws_zhengju',
      dialogTitle: '证据资料上传',
      // filterForm: {
      //   entrustContract: {}
      // }, // 特殊

      baseInfo: [
        // { key: 'province', label: '省' },
        // { key: 'city', label: '市' },
        // { key: 'county', label: '县' },
        // { key: 'town', label: '镇' },
        // { key: 'village', label: '村' },
        { key: 'areaName', label: '地区' },

        { key: 'caseName', label: '委托合同' },
      ],

      rules: {
        // fileNameAndIds: [{ required: true, message: '必填', trigger: 'blur' }],
        contractId: [{ required: true, message: '必填', trigger: 'change' }],
        // number1: [{ required: true, trigger: 'blur', validator: this.$t.validator_number_must }],
        // number2: [{ trigger: 'blur', validator: this.$t.validator_number }],
        // date1: [{ required: true, trigger: 'blur', validator: this.$t.validator_number_8 }],
        // date2: [{ trigger: 'blur', validator: this.$t.validator_number_8 }],
      },
      formItems: [
        { type: 'select_s', key: 'contractId', label: '委托合同', options: [], remoteMethod: this.getContractData },
        { type: 'document', key: 'fileNameAndIds', label: '输送人员名册', index: 1, limitNum: 5, accept: '.docx,.xlsx' },
      ],
      formItems_: [],
    }
  },
  // computed: {
  //   importAction() {
  //     // return this.$api.baseUrl + '/user/sync/company/' + this.userInfo.areaId
  //     return this.$api.baseUrl + this.$api.url_import(this.sign)
  //   },
  // },
  methods: {
    modifyHandlerBefore() {
      let {
        entrustContract
      } = this.selectData
      console.log(entrustContract.caseName)
      this.formItems[0].options = [
        {
          label: entrustContract.caseName,
          value: entrustContract.id,
        }
      ]
    },
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
    editSubmitHandler(result) {
      console.log(`%cresult:`, 'color: #00f;', result)
      // let { id, province, city, county, town, village } = result
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
      let item = this.formItems[0].options.find(x => x.value === result.contractId)
      let { province, city, county, town, village } = item
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
      let rData = { province, city, county, town, village }
      // let rData = {}
      const mapList = [
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        'contractId',
        'fileNameAndIds',
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
      ]

      if (this.isCreate) {
        mapList.forEach(x => {
          result[x] ? rData[x] = result[x] : ''
        })
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        rData.docType = this.docType
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        console.log(rData)
        
        this.$api.util_create(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('创建成功！')
            this.$refs.DialogEdit.isShowDialog = false
            this.$refs.DialogEdit.clearHandler()
            this.searchHandler()
          } else { this._status(res.data) }
        })
      }

      else {
        mapList.forEach(x => {
          if (this.selectData[x] !== result[x]) {
            rData[x] = result[x]
          }
        })
        rData.id = this.selectData.id // 绑定修改的数据id
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        console.log(rData)

        this.$api.util_modify(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('修改成功！')
            this.$refs.DialogEdit.isShowDialog = false
            this.$refs.DialogEdit.clearHandler()
            this.searchHandler()
          } else { this._status(res.data) }
        })
      }
    },
    getData(rD = {}) {
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
      rD.docType = this.docType
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
      this.$api.util_search(this.sign, rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c_R:`, 'color: #f00;', _R)
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
          // this.tableData = _R
          this.tableData = _R.map(x => {
            x.caseName = x.entrustContract && x.entrustContract.caseName
            x.areaName = x.province + x.city + x.county + x.town + x.village
            return x
          })
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
          this.pageData.total = res.data.size
        } else { this._status(res.data) }
      })
    },
    getContractData(val) {
      console.log(val, this.areaIds_x)
      let rD = {
        areaId: this.areaIds_x[this.areaIds_x.length - 1],
        caseName: val,
      }
      // console.log(rD)
      this.$api.util_search('yz_wt_weituo', rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          this.formItems[0].options = _R.map(x => {
            return {
              label: x.caseName,
              value: x.id,
              province: x.province,
              city: x.city,
              county: x.county,
              town: x.town,
              village: x.village,
            }
          })
        } else { this._status(res.data) }
      })
    },
  },
  created() {
    const powerList = this.userInfo.privilegesList
    const powerStr = powerMap[this.sign]
    // console.log(powerStr)
    this.btnShow.search = true
    // const mapList = ['search','create','modify','delete','import','export']
    const mapList = ['create','modify','delete','import','export']
    if (this.userInfo.admin) {
      mapList.forEach(x => {
        this.btnShow[x] = true
      })
    } else {
      mapList.forEach(x => {
        if (x && powerList.includes(powerStr + '-' + x)) {
          this.btnShow[x] = true
        }
      })
    }
  },
}
</script>

<style lang='scss' scoped>
.section-filter{display: flex;overflow-x: auto;}
.section-filter>div{flex-shrink: 0;}
.filter-col{display: flex;flex-direction: column;}
.filter-area{display: flex;}
.filter-area-label{margin:5px 10px 0 50px;font-size: 14px;}
.filter-btn{margin-left: 20px;}

.section-btns{padding-left: 15px;margin-right: 10px;display: flex;}
/deep/.section-btns .el-upload-list{display: none;}





.file-item{height: 40px;line-height: 40px;display: flex;}
.file-name{
  display: inline-block;min-width: 120px;max-width: 200px;padding: 0 10px;
  overflow: hidden;white-space: nowrap;text-overflow: ellipsis;
}
</style>